<template>
  <v-container fluid style="margin-top: -12px">
    <product-component></product-component>
  </v-container>
</template>

<script>
import ProductComponent from "./ProductComponent";
export default {
  name: "ViewProducts",
  props: ["syID"],
  components: { ProductComponent }
};
</script>

<style scoped></style>
